<app-pan-card [isPageContainer]="true" pageContainerSize="xl" header="Create Walkout Review">
  <section class="flex flex-col gap-2">
    <div class="flex gap-4">
      <app-page-select-branch
        class="flex-1"
        label="Select Branch"
        placeholder="Select branch..."
        [autoSelectBranchIds]="autoSelectBranchIds()"
        [selected]="branch()"
        (selectedChange)="onBranchChange($event)"
      />

      <app-page-select-location
        #locationSelect
        class="flex-1"
        label="Select Location"
        [placeholder]="!branchId() ? 'Select a branch first' : ''"
        [autoSelectLocationIds]="autoSelectLocationIds()"
        [selected]="location()"
        (selectedChange)="onLocationChange($event)"
        [disabled]="!branchId()"
      />
    </div>

    <div class="flex gap-4">
      <app-pan-form-control class="flex-1">
        <app-pan-floating-label>Kiosk Organization (branch alias)</app-pan-floating-label>
        <ng-select
          class="w-full"
          [items]="branchAliasOptions()"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [searchable]="true"
          [clearable]="true"
          [disabled]="!branchId() || !locationId()"
          placeholder="Select kiosk organization..."
          [(ngModel)]="selectedBranchAliasId"
          (ngModelChange)="onBranchAliasChange($event)"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
      </app-pan-form-control>

      <app-pan-form-control class="flex-1">
        <app-pan-floating-label>Kiosk (location alias)</app-pan-floating-label>
        <ng-select
          class="w-full"
          [items]="locationAliasOptions()"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [searchable]="true"
          [clearable]="true"
          [disabled]="!locationId() || !selectedBranchAliasId()"
          placeholder="Select kiosk..."
          [(ngModel)]="selectedKioskId"
          (ngModelChange)="onKioskChange($event)"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }}
            <span class="text-sm italic"> ({{ item.branch_alias_name }})</span>
          </ng-template>
        </ng-select>
      </app-pan-form-control>
    </div>

    <div class="flex gap-4 items-end">
      <app-pan-form-control class="flex-1">
        <app-pan-floating-label>Unique ID</app-pan-floating-label>
        <input
          panInput
          type="text"
          [(ngModel)]="uniqueId"
          placeholder="Enter or generate UUID"
          [disabled]="isCreatingWalkout() || (createdWalkoutId() !== undefined && createdReviewId() === undefined)"
        />
      </app-pan-form-control>

      <app-pan-button
        color="info"
        (click)="generateUuid()"
        [disabled]="isCreatingWalkout() || (createdWalkoutId() !== undefined && createdReviewId() === undefined)"
      >
        Generate UUID
      </app-pan-button>
    </div>

    <div class="flex gap-4 items-center">
      <app-pan-form-control class="w-64">
        <app-pan-floating-label>Walkout Date</app-pan-floating-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [matDatepicker]="picker"
            [ngModel]="walkoutDateDate()"
            (ngModelChange)="onDateChange($event)"
            placeholder="Choose date"
          />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </app-pan-form-control>

      <app-pan-form-control class="w-48">
        <app-pan-floating-label>Walkout Time</app-pan-floating-label>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput type="time" step="1" [ngModel]="walkoutTime()" (ngModelChange)="onTimeChange($event)" />
        </mat-form-field>
      </app-pan-form-control>

      <div class="flex gap-2 items-center">
        <app-pan-button color="default" (click)="setNow()">Now</app-pan-button>
      </div>

      <div class="text-sm">Timezone: {{ locationTimezoneDisplay() }}</div>
    </div>

    <div class="flex gap-4 items-center">
      <app-pan-form-control class="w-48">
        <app-pan-floating-label>Theft Score</app-pan-floating-label>
        <input panInput type="number" [(ngModel)]="theftScore" min="0" />
      </app-pan-form-control>

      <app-pan-form-control class="w-56">
        <app-pan-floating-label>Walkout Status</app-pan-floating-label>
        <input panInput type="text" [(ngModel)]="walkoutStatus" placeholder="e.g. Review Theft" />
      </app-pan-form-control>

      <label>
        <input type="checkbox" panCheckbox [(ngModel)]="matchingTransaction" />
        Matching Transaction
      </label>
    </div>

    <div class="flex gap-4 items-center">
      <app-pan-form-control class="w-64">
        <app-pan-floating-label>Camera</app-pan-floating-label>
        <ng-select class="w-full" [items]="[]" [clearable]="true" placeholder="Select camera"></ng-select>
      </app-pan-form-control>
    </div>

    <section class="mt-4">
      <app-pan-section-header title="Walkout Items">
        <app-pan-button action color="info" (click)="addTxnItem()">Add Item</app-pan-button>
      </app-pan-section-header>
      <div class="flex flex-col gap-3">
        @for (item of transactionItems(); let i = $index; track $index) {
          <div class="grid gap-3 grid-cols-[2fr_1fr_auto]">
            <app-pan-form-control>
              <app-pan-floating-label>Item</app-pan-floating-label>
              <input panInput type="text" [(ngModel)]="item.description" placeholder="Item name" />
            </app-pan-form-control>
            <app-pan-form-control>
              <app-pan-floating-label>Price</app-pan-floating-label>
              <input panInput type="number" step="0.01" [(ngModel)]="item.price" />
            </app-pan-form-control>
            <div class="flex items-end">
              <app-pan-button color="danger" icon="delete" (click)="removeTxnItem(i)"></app-pan-button>
            </div>
          </div>
        }
      </div>
    </section>

    <section class="mt-4">
      <app-pan-section-header title="Video (MP4)"></app-pan-section-header>
      <div class="flex items-center gap-3 flex-wrap">
        <div class="flex items-center gap-2">
          <input type="file" accept="video/mp4" (change)="onVideoSelected($event)" />
          @if (videoFile(); as v) {
            <span class="text-xs text-gray-500">Selected: {{ v.name }}</span>
          } @else {
            <span class="text-xs text-gray-500">No video selected</span>
          }
        </div>
        <app-pan-form-control class="w-48">
          <app-pan-floating-label>Offset (seconds)</app-pan-floating-label>
          <input panInput type="number" min="0" step="1" [(ngModel)]="videoOffsetSeconds" />
        </app-pan-form-control>
        <app-pan-form-control class="w-48">
          <app-pan-floating-label>Duration (seconds)</app-pan-floating-label>
          <input panInput type="number" min="0" step="1" [(ngModel)]="videoDurationSeconds" />
        </app-pan-form-control>
      </div>
    </section>

    <section class="mt-4">
      <app-pan-section-header title="Image"></app-pan-section-header>
      <div class="flex items-center gap-3">
        <div class="w-20 h-20 flex items-center justify-center border rounded bg-gray-50 overflow-hidden">
          @if (photoRows()[0]?.previewUrl; as url) {
            <img [src]="url" class="object-cover w-full h-full" alt="preview" />
          } @else {
            <span class="text-xs text-gray-500 px-2">No image</span>
          }
        </div>

        <div class="flex items-center gap-2">
          <input type="file" accept="image/*" (change)="onPhotoSelected($event, 0)" />
        </div>
      </div>
    </section>

    <section class="flex flex-col gap-4 mt-6">
      <div class="flex justify-end items-center gap-4">
        @if (createdWalkoutId(); as walkoutId) {
          <span class="text-sm">Walkout ID: {{ walkoutId }}</span>
        }
        <app-pan-button
          (click)="createWalkout()"
          [disabled]="
            !canCreateWalkout() ||
            isCreatingWalkout() ||
            (createdWalkoutId() !== undefined && createdReviewId() === undefined)
          "
          [state]="isCreatingWalkout() ? 'loading' : 'default'"
        >
          Create Walkout
        </app-pan-button>
      </div>

      <div class="flex justify-end items-center gap-4">
        @if (createdReviewId(); as reviewId) {
          <span class="text-sm">Review ID: {{ reviewId }}</span>
        }
        <app-pan-button
          color="primary"
          (click)="createReview()"
          [disabled]="
            !canCreateReview() ||
            isCreatingReview() ||
            isCreatingWalkout()
          "
          [state]="isCreatingReview() ? 'loading' : 'default'"
        >
          Create Review
        </app-pan-button>
      </div>
    </section>
  </section>
</app-pan-card>
